import { render, staticRenderFns } from "./festivalList.vue?vue&type=template&id=11720baa&scoped=true&"
import script from "./festivalList.vue?vue&type=script&lang=js&"
export * from "./festivalList.vue?vue&type=script&lang=js&"
import style0 from "./festivalList.vue?vue&type=style&index=0&id=11720baa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11720baa",
  null
  
)

export default component.exports